module.exports = __webpack_public_path__ + "static/media/logout_icon.8c6ab56d.svg";